import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { siteBranding, navigationMenu } from '../data';
import { getResizedImageUrl } from '../lib/utils';

export default function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => {
    if (path === '/') {
      return location.pathname === '/';
    }
    return location.pathname.startsWith(path);
  };

  return (
    <header className="sticky top-0 z-[100] bg-brand-bg/90 backdrop-blur-md border-b border-brand-primary/10 transition-all duration-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20 sm:h-24">
          {/* Logo Section */}
          <div className="flex-shrink-0">
            <Link to="/" className="flex items-center gap-3 group" aria-label="Moon Yoga Fredericia Hjem">
              <img
                src={getResizedImageUrl(siteBranding.logo, "width=180,quality=90,format=auto")}
                alt="Moon Yoga Fredericia Logo"
                className="h-12 sm:h-16 w-auto object-contain transition-transform duration-500 group-hover:rotate-6"
                width="180"
                height="64"
                loading="eager"
              />
              <div className="flex flex-col">
                <span className="font-serif text-xl sm:text-2xl tracking-wide text-brand-text group-hover:text-brand-primary transition-colors duration-300">
                  Moon Yoga
                </span>
                <span className="text-[10px] sm:text-xs tracking-[0.2em] uppercase text-brand-muted">
                  Fredericia
                </span>
              </div>
            </Link>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8 lg:gap-10">
            {navigationMenu.map((item) => (
              <Link
                key={item.href}
                to={item.href}
                className={`relative py-2 text-sm lg:text-base font-medium tracking-wide transition-colors duration-300 ${
                  isActive(item.href)
                    ? 'text-brand-primary font-semibold'
                    : 'text-brand-text/80 hover:text-brand-primary'
                }`}
              >
                {item.label}
                {isActive(item.href) && (
                  <span className="absolute bottom-0 left-0 right-0 h-[2px] bg-brand-primary rounded-full animate-fade-in" />
                )}
              </Link>
            ))}
          </nav>

          {/* Mobile Menu Button */}
          <div className="hidden max-md:flex items-center">
            <button
              onClick={() => setIsOpen(!isOpen)}
              type="button"
              className="inline-flex items-center justify-center p-2 rounded-full text-brand-text hover:text-brand-primary hover:bg-brand-primary/5 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-brand-primary transition-all duration-300"
              aria-controls="mobile-menu"
              aria-expanded={isOpen}
            >
              <span className="sr-only">Åbn hovedmenu</span>
              <i className={`fa-light ${isOpen ? 'fa-xmark' : 'fa-bars'} text-2xl`} />
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={`hidden max-md:block transition-all duration-300 ease-in-out ${
          isOpen ? 'max-h-screen opacity-100 visible' : 'max-h-0 opacity-0 invisible overflow-hidden'
        }`}
        id="mobile-menu"
      >
        <div className="px-4 pt-2 pb-6 space-y-2 bg-brand-bg border-t border-brand-primary/10 shadow-lg">
          {navigationMenu.map((item) => (
            <Link
              key={item.href}
              to={item.href}
              onClick={() => setIsOpen(false)}
              className={`block px-4 py-3 rounded-xl text-base font-medium transition-all duration-300 ${
                isActive(item.href)
                  ? 'bg-brand-primary/10 text-brand-primary font-semibold'
                  : 'text-brand-text/80 hover:bg-brand-primary/5 hover:text-brand-primary'
              }`}
            >
              {item.label}
            </Link>
          ))}
        </div>
      </div>
    </header>
  );
}
